import { Button } from '@one-thd/sui-atomic-components';
import { Car } from '@one-thd/sui-icons';
import React from 'react';
import '../../../../styles/order-details.scss';
import { pushEventInfo } from '../../../../utils/analytics';
export var CurbsidePickup = function (_a) {
    var orderId = _a.orderId, storeId = _a.storeId;
    var triggerCurbsideFn = function () {
        var _a;
        // Analytics
        pushEventInfo({
            category: { primaryCategory: 'button submission' },
            eventInfo: { eventName: 'Curbside Pickup' },
            myAccount: { settings: 'Curbside Pickup button clicked' },
        });
        (_a = window === null || window === void 0 ? void 0 : window.LIFE_CYCLE_EVENT_BUS) === null || _a === void 0 ? void 0 : _a.trigger('NATIVE_APP.OPEN_CURBSIDE', {
            storeId: storeId,
            orderId: orderId,
        });
    };
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(Button, { startIcon: Car, onClick: triggerCurbsideFn }, "Get it Curbside")));
};
export default CurbsidePickup;
